export default __webpack_public_path__ + "static/media/408 1.811cfc44.png";